import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';

import { SportsCacheService } from '@frontend/sports/betting-offer/feature/sports-cache';
import { CountItem } from '@frontend/sports/common/core/data-access/sport-model';
import { CompetitionRouteService } from '@frontend/sports/competition-list/feature';
import { StandingsData } from '@frontend/sports/grid/core/feature/model';
import { isArray } from 'lodash-es';
import { Observable, map } from 'rxjs';

import { PruneHelperService } from '../competition-list/services/prune-helper.service';
import { VirtualCompetitionService } from '../competition-list/services/virtual-competition.service';
import { StandingsService } from '../standings/standings.service';
import { StandingsPageResponse } from './standings-page.model';

@Injectable({ providedIn: 'root' })
export class StandingsPageResolver {
    private pruneHelperService = inject(PruneHelperService);
    private standingsService = inject(StandingsService);
    private sportsCacheService = inject(SportsCacheService);
    private competitionRouteService = inject(CompetitionRouteService);
    private virtualCompetitionService = inject(VirtualCompetitionService);

    sport?: CountItem;
    standingsData: StandingsData = {
        groups: [],
    };

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<StandingsPageResponse | undefined> {
        const response: StandingsPageResponse = {
            route: {},
        };

        return this.sportsCacheService.getSport(route.params.sport).pipe(
            map((sport) => {
                response.route = this.competitionRouteService.params();

                sport = this.pruneHelperService.prune(sport, { ...response.route, virtualCompetitionGroup: undefined });
                response.sport = sport;
                response.standingsData = response.route.league
                    ? this.getStandings(sport, response.route.virtualCompetitionGroup, response.route.league, response.route.isVirtual)
                    : {
                          groups: [],
                      };
                response.virtualCompetition = this.virtualCompetitionService.getCompetition(sport, response.route);

                return response;
            }),
        );
    }

    private getStandings(
        sport: CountItem | undefined,
        selectedVirtualGroupId?: number,
        selectedVirtualCompetition?: number | number[] | undefined,
        isVirtual?: boolean | undefined,
    ): StandingsData {
        if (sport) {
            const groups = this.standingsService.getStandingsGroups({ sport, selectedVirtualGroupId });
            const league = isVirtual ? (isArray(selectedVirtualCompetition) ? undefined : selectedVirtualCompetition) : undefined;

            return {
                groups,
                virtualCompetitionId: league,
            };
        }

        return {
            groups: [],
        };
    }
}
